<div class="cell title">
    <div [innerHTML]="row().name"></div>
</div>

<div *ngFor="let value of row().outValues; index as i" class="cell">
    <div [innerHTML]="value"></div>
</div>

<div class="cell sub-total" *ngIf="row().outTotal != null">
    <div [innerHTML]="row().outTotal"></div>
</div>

<div *ngFor="let value of row().inValues; index as i" class="cell">
    <div [innerHTML]="value"></div>
</div>

<div class="cell sub-total" *ngIf="row().inTotal != null">
    <div [innerHTML]="row().inTotal"></div>
</div>

<div class="cell total">
    <div [innerHTML]="row().total"></div>
</div>
